import type { SVGProps } from "react";
import * as React from "react";

const SvgCoffee = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 8V7zm0 8v1zm-1-1a1 1 0 1 0 0 2zM2 8V7a1 1 0 0 0-1 1zm0 9H1zM7 1a1 1 0 0 0-2 0zM5 4a1 1 0 0 0 2 0zm6-3a1 1 0 1 0-2 0zM9 4a1 1 0 0 0 2 0zm6-3a1 1 0 1 0-2 0zm-2 3a1 1 0 1 0 2 0zm5 5h1V7h-1zm1 0a3 3 0 0 1 2.121.879l1.415-1.415A5 5 0 0 0 19 7zm2.121.879A3 3 0 0 1 22 12h2a5 5 0 0 0-1.465-3.536zM22 12a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 24 12zm-.879 2.121A3 3 0 0 1 19 15v2a5 5 0 0 0 3.535-1.464zM19 15h-1v2h1zM2 9h16V7H2zm15-1v9h2V8zm0 9a3 3 0 0 1-.879 2.121l1.415 1.415A5 5 0 0 0 19 17zm-.879 2.121A3 3 0 0 1 14 20v2a5 5 0 0 0 3.535-1.465zM14 20H6v2h8zm-8 0a3 3 0 0 1-2.121-.879l-1.415 1.415A5 5 0 0 0 6 22zm-2.121-.879A3 3 0 0 1 3 17H1a5 5 0 0 0 1.464 3.535zM3 17V8H1v9zM5 1v3h2V1zm4 0v3h2V1zm4 0v3h2V1z"
    />
  </svg>
);
export default SvgCoffee;
